/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateFindByEmailRequest, CandidateFindByEmailResponse } from '../types/CandidateFindByEmail'

/**
 * POST /candidates/find
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateController.php CandidateController::findByEmail
 */
export async function candidateFindByEmail(
	data: CandidateFindByEmailRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateFindByEmailResponse>> {
	return axiosInstance.post('/candidates/find', data, config)
}
